import * as React from 'react';
import styled, { StyledFunction } from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';

interface ISectionProps {
  align?: string;
}
const SectionDiv: StyledFunction<ISectionProps & React.HTMLProps<HTMLInputElement>> = styled.div;

const OrganizationSettingSection = SectionDiv`
  display: inline-flex;
  flex: 1;
  justify-content: ${props => (props.align === 'end' ? 'flex-end' : 'initial')};
  align-items: center;
  min-width: 0;
  z-index: 1;
`;

const OrganizationSettingTitle = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${colors.slate__4c566c};
`;

const BackLink = styled.span`
  padding-right: 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  color: ${colors.denim__5fa9ff};
`;

interface IProps {
  toggleMode: (e: React.SyntheticEvent<HTMLElement>) => void;
}
export class OrganizationSettingToolbar extends React.PureComponent<IProps, {}> {
  public render() {
    return (
      <React.Fragment>
        <OrganizationSettingSection>
          <OrganizationSettingTitle>フォローを外した組織はメニューに表示されなくなります。（元に戻すこともできます。）</OrganizationSettingTitle>
        </OrganizationSettingSection>
        <OrganizationSettingSection align="end">
          <BackLink onClick={this.props.toggleMode}>← Monitorに戻る</BackLink>
        </OrganizationSettingSection>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/Toolbar/OrganizationSettingToolbar.tsx